<script setup lang="ts">
import { getFoodItemInfo } from '@caks/shared/api/user.route'
import { useAccountStore } from '@caks/shared/store/store.account'
import { FoodExtraModification, FoodItem } from '@caks/shared/types/types.api'
import { CartItem, SelectedModificator } from '@caks/shared/types/types.user'
import { ChipButton } from '@caks/uikit/chip'
import { IconCheck } from '@caks/uikit/icon/'

interface Props {
  item: FoodItem
}

const props = defineProps<Props>()
const router = useRouter()

const onChipClick = async () => {
  if (props.item.has_required_modifications) {
    router.push(`/food/${props.item.id}`)
  } else {
    isAddedToCart.value = true
    addToCart(props.item.id)

    setTimeout(() => {
      isAddedToCart.value = false
    }, 700)
  }
}

const store = useAccountStore()
const isAddedToCart = ref(false)
const selectedBaseMods = ref<SelectedModificator[]>([])
const allFoodInfo = shallowRef<FoodItem | null>(null)
const extraIngredientsSelected = ref<FoodExtraModification[]>([])
const removedCheckboxList = ref<number[]>([])
const removableList = computed(() => {
  return allFoodInfo.value?.available_modifications.removable_modifications
})
const removedList = computed(() => {
  if (removableList.value) {
    return removableList.value.filter((el) => {
      return removedCheckboxList.value.includes(el.id)
    })
  }
  return []
})
const addToCart = async (foodId: number) => {
  let data: any

  //@ts-ignore
  const res = await getFoodItemInfo(foodId)

  if (res.status === 'ERR') throw res.description ?? res.message

  data = res.data[0]

  const baseVariants = (data as FoodItem).available_modifications.base_modifications

  //@ts-ignore
  selectedBaseMods.value = baseVariants.map((el) => {
    return { modification_id: el.id, name: el.name, variant_id: el.available_variants[0].id }
  })

  allFoodInfo.value = data as FoodItem

  allFoodInfo.value.available_modifications.ingredients.sort((a, b) => {
    if (a.required && !b.required) return -1
    if (!a.required && b.required) return 1
    return 0
  })
  if (allFoodInfo.value) {
    const cartExtraMods = extraIngredientsSelected.value.map((el) => {
      return {
        modification_id: el.id,
        name: el.name,
      }
    })
    const cartRemovedMods = removedList.value.map((el) => {
      return {
        modification_id: el.id,
        name: el.name,
      }
    })

    const cartItem: CartItem = {
      item: allFoodInfo.value,
      //@ts-ignore
      extraModificators: cartExtraMods,
      //@ts-ignore
      removedModificators: cartRemovedMods,
      //@ts-ignore
      baseModificators: selectedBaseMods.value,
      cost: allFoodInfo.value.base_cost,
    }

    store.addToCart(cartItem)
    localStorage.setItem('cart', JSON.stringify(store.cart))
  }
}
</script>

<template>
  <div class="searched-item" @click="router.push(`/food/${item.id}`)">
    <img class="searched-item__image" :src="item.main_media" alt="product-image" />
    <div class="searched-item__info">
      <h4>{{ item.name }}</h4>
      <p>{{ item.description }}</p>
      <chip-button @click.stop="onChipClick" style="width: 80px">
        <span v-if="!isAddedToCart">от {{ item.base_cost }}₽</span>
        <icon-check v-else />
      </chip-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.searched-item {
  display: flex;
  gap: 16px;
  align-items: center;
  cursor: pointer;

  &__image {
    width: 116px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 12px;

    h4 {
      color: $primary-text;
      @include h4-6;
    }

    p {
      color: $sub-text;
      @include h7-1;
    }

    button {
      width: fit-content;
    }
  }
}
</style>
